import { createFileRoute, useNavigate, useRouter } from '@tanstack/react-router';
import { ordersQueries } from '@/entities/order';
import { OrderDetailPage } from '@/pages/order-detail';

export const Route = createFileRoute('/orders/$orderId/')({
  loader: ({ context, params }) =>
    // Non-blocking prefetch — the page renders its shell + skeleton while the
    // detail loads, so navigation never stalls on a slow backend.
    void context.queryClient
      .prefetchQuery(ordersQueries.detail(params.orderId))
      .catch(() => undefined),
  component: OrderDetailRoute,
});

function OrderDetailRoute() {
  const { orderId } = Route.useParams();
  const navigate = useNavigate();
  const router = useRouter();
  return (
    <OrderDetailPage
      orderId={orderId}
      onBack={() => {
        if (window.history.length > 1) router.history.back();
        else void navigate({ to: '/orders' });
      }}
      onOpenOrder={(id) =>
        void navigate({ to: '/orders/$orderId', params: { orderId: String(id) } })
      }
    />
  );
}
